import React from "react";
import PropTypes from "prop-types";

import { faCommentAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "semantic-ui-react";

import CommentIconPlus from "./CommentIconPlus";

export default function CommentIconTooltipGroup({
  additionalStyles,
  disabled,
  hasComments,
  onClick,
}) {
  return (
    <Icon.Group
      data-test="comment-icon"
      className={
        hasComments ? "dark_grey_on_hover" : "show_on_hover dark_grey_on_hover"
      }
      style={{ fontSize: "13pt", ...additionalStyles }}
      onClick={onClick}
      disabled={disabled}
      title="Comment"
    >
      <FontAwesomeIcon
        className="clickable"
        icon={faCommentAlt}
        color={hasComments ? "grey" : undefined}
      />
      {!disabled && <CommentIconPlus hasComments={hasComments} />}
    </Icon.Group>
  );
}

CommentIconTooltipGroup.propTypes = {
  additionalStyles: PropTypes.object,
  disabled: PropTypes.bool.isRequired,
  hasComments: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

CommentIconTooltipGroup.defaultProps = {
  additionalStyles: {},
};
